import {jqGetJson} from "../helpers";

export function initK1ActionHref() {
	$('body').on('click', 'a[k1-action-href]', function (event) {
		event.preventDefault()
		var $el = $(this)
		jqGetJson($el.attr('href'), function (response) {
			if (response.result) {
				var successCallback = $el.data('success')
				var successMessage = $el.data('success-msg')
				if (typeof successCallback !== 'undefined') {
					window[successCallback].call()
				}
				if (typeof successMessage !== 'undefined') {
					staticNotification.success(successMessage);
				} else {
					staticNotification.success('Požadavek úspěšně proveden.');
				}

				if ($el.data('after') == 'reload-detail') {
					reloadGridDetailContent();
				}

				if ($el.data('after') == 'reload') {
					window.location.reload();
				}

				if (typeof $el.data('detach') !== 'undefined') {
					$el.closest('tr').detach()
					$el.closest('li').detach()
					$el.closest('[detach-container]').detach()
				}

				if (typeof $el.data('after-href') !== 'undefined') {
					window.location.href = $el.data('after-href');
				}
			} else {
				staticNotification.error(response.errorMessage);
			}
		})
	})

}
